import styled from 'styled-components';

import { spacing, colors } from 'ui/theme';

import { TABLE_COLUMNS, ORDERED_TABLE_COLUMNS } from '../constants';

const FIRST_COLUMN = ORDERED_TABLE_COLUMNS[0];
const LAST_COLUMN = ORDERED_TABLE_COLUMNS[ORDERED_TABLE_COLUMNS.length - 1];

type CellProps = {
  columnId: TABLE_COLUMNS;
  $isEven: boolean;
};

export const Cell = styled.div<CellProps>`
  background-color: ${({ $isEven }) => ($isEven ? colors.white : colors.backgroundSecondary)};
  grid-column: col-${({ columnId }) => columnId} / span 1;
  padding: ${spacing.base} 0;
  ${({ columnId }) => columnId === FIRST_COLUMN && `padding-left: ${spacing.double};`}
  ${({ columnId }) => columnId === LAST_COLUMN && `padding-right: ${spacing.double};`}
`;
